import axios from '@/api';
import authHeader from './auth-header';

import store from '../store'

class FileService {
    getFileContent(buttonName, buttonType) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileList',
            {
                name: buttonName,
                type: buttonType,
            },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(response => {
                //console.log(response.data)
                return response.data
            })
            .catch(error => {
                if (error.response?.status === 401) {
                    console.warn("인증 실패: 로그인 다시 필요");
                } else if (error.response?.status >= 500) {
                    console.error("서버 오류 발생:", error.response.status);
                }

                throw error;
            });
    }

    postFileDownChk(fileName) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileDownChk', {
            fileName
        },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(response => {
                return response;
            }).catch(error => {
                console.log(error);
            })
    }

    async getFileDown(file) {
        const downloadUrl = `${process.env.VUE_APP_API_URL}file/fileDown?name=${encodeURIComponent(file)}`;
        
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = file;
        document.body.appendChild(a);
        a.click();
        a.remove();
    }

    async postFileDownload(file, options = {}) {
        return new Promise((resolve, reject) => {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = process.env.VUE_APP_API_URL + 'file/fileDown';
            form.target = options.target || '_blank';
            form.style.display = 'none';

            // 파일 이름 또는 기타 필드
            const fileInput = document.createElement("input");
            fileInput.name = "name";
            fileInput.value = file;
            form.appendChild(fileInput);

            // 인증 토큰을 input으로 전달 (예: JWT)
            const headers = authHeader();
            if (headers['x-access-token']) {
                const tokenInput = document.createElement("input");
                tokenInput.name = "x-access-token";  // 서버에서 이 필드를 읽어야 함
                tokenInput.value = headers['x-access-token'];
                form.appendChild(tokenInput);
            }

            document.body.appendChild(form);

            try {
                form.submit();
                resolve();
            } catch (error) {
                reject(error);
            } finally {
                setTimeout(() => {
                    document.body.removeChild(form);
                }, 1000);
            }
        });
    }

    postFileOpen(file) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileDownChk',
            {

            },
            {
                headers: authHeader(),
                withCredentials: true,
            }).then(response => {
                if (response.status == 200) {
                    var newForm = document.createElement("form");
                    newForm.setAttribute("method", "POST");
                    newForm.setAttribute("action", process.env.VUE_APP_API_URL + 'file/fileOpen')

                    var newInput = document.createElement("input");
                    newInput.setAttribute('type', 'hidden');
                    newInput.setAttribute("name", "name");
                    //newInput.setAttribute("value", file.name);
                    newInput.setAttribute("value", file);
                    newForm.appendChild(newInput);

                    document.body.appendChild(newForm);
                    newForm.submit();
                    document.body.removeChild(newForm);
                    //console.log(newInput.textContent);
                    return newInput.textContent
                }
            });
    }

    postTextOpen(file, filePath, offset, limit, token) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/textOpen',
            {
                fileName: file,
                filePath,
                offset,
                limit,
                token,
            },
            {
                headers: authHeader(),
                withCredentials: true,
            }).then(response => {
                //console.log(response.data);
                return response.data;
        });
    }

    async postFileUpload(formData, onProgress) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_API_URL + 'file/fileUpload',
                formData,
                {
                    onUploadProgress: (e) => {
                        if (onProgress) onProgress(e);
                    },
                    headers: {
                        ...authHeader(),
                        'Content-Type': 'multipart/form-data',
                    },
                    withCredentials: true,
                    maxContentLength: Infinity,
                    maxBodyLength: Infinity,
                    timeout: 0,
                }
            );

            return response;
        } catch (e) {
            console.error('postFileUpload error:', e);
            throw e;
        }
    }

    //resetUploadProgress() {
    //    store.state.files.upload.uploadedBytes = 0;
    //    store.dispatch('files/upload/setUploadPercent', '0');
    //}

    postFileRecycle(array) { 
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileRecycle', {
            array
        },
        {
            headers: authHeader(),
            withCredentials: true
            }).then(response => {
            return response;
        }).catch(error => {
            console.log(error);
        })
    }

    postFileDelete(array, dir) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileDelete', {
            array,
            dir
        },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(response => {
                return response;
            }).catch(error => {
                console.log(error);
            })
    }

    postFolderCreate(newDirName) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/folderCreate', {            
            newDirName
        },
        {
            headers: authHeader(),
            withCredentials: true
        }
        ).then(response => {
            return response;
        }).catch(error => {
            console.log(error);
        })
    }

    async getAllFilesInFolder(oldDir, folder) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_API_URL + "file/getAllFilesInFolder",
                { dir: oldDir, folder },
                {
                    headers: authHeader(),
                    withCredentials: true,
                }
            );
            return response.data; // 파일 경로 배열
        } catch (error) {
            console.error("getAllFilesInFolder 에러:", error);
            throw error;
        }
    }

    postFileMove(oldDir, newDir, subDir, file) {        
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileMove', {
            oldDir,
            newDir,
            subDir,
            file,
        }, {
            headers: authHeader(),
            withCredentials: true
        }).then(response => response.data)
            .catch(error => {
                console.error('postFileMove 에러:', error);
                throw error;
            });
    }

    postFileCopySingle(oldDir, newDir, subDir, file) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileCopy', {
            oldDir,
            newDir,
            subDir,
            file,
        }, {
            headers: authHeader(),
            withCredentials: true
        }).then(response => response.data)
            .catch(error => {
                console.error('postFileCopySingle 에러:', error);
                throw error;
            });
    }

    postFileCopy(moveArray, newDir) {
        moveArray = JSON.parse(JSON.stringify(moveArray))
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileCopy', {
            moveArray,
            newDir,
        },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(response => {
                return response.data;
            }).catch(error => {
                console.log(error);
            })
    }

    postMediaOpen(fileName, mediaToken) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/mediaOpen', {
            fileName,
            mediaToken
        },
        {
            headers: authHeader(),
            withCredentials: true
            }).then(res => {
            return res;
        }).catch(error => {
            console.log(error);
        })
    }

    postFileRename(oldName, newName) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileRename', {
            oldName,
            newName,
        },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(response => {
                return response;
            }).catch(error => {
                console.log(error);
            })
    }

    //getFileLink(file) {
    //    return axios.get(process.env.VUE_APP_API_URL + 'file/images',
    //        {
    //            //params: { file: file },
    //            params: { file: file },
    //            headers: authHeader(),
    //            withCredentials: true
    //        }).then(response => {
    //            //console.log(response.data)
    //            return response.data
    //        });
    //}

    postCreateLinkToken(fileName, dir) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/createLink', {
            fileName,
            dir,
        },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(res => {
                return res.data;
            }).catch(error => {
                console.log(error);
            })
    }

    // ⭐ 새로 추가: ZIP 엔트리 가져오기
    postZipEntries(zipFilename, token, dir) {
        return axios.post(process.env.VUE_APP_API_URL + "file/zip/entries", {
            token,
            dir,
            zipFilename,
        }, {
            headers: authHeader(),
            withCredentials: true
        })
            .then(res => res.data)
            .catch(err => {
                console.error(err);
            });
    }

    // 파일 스트림 URL 반환
    getZipFileUrl(zipFilename, token, curZipDir, fileName) {
        return `${process.env.VUE_APP_API_URL}file/zip/file`
            + `?token=${token}`
            + `&curZipDir=${encodeURIComponent(curZipDir)}`
            + `&zipFilename=${encodeURIComponent(zipFilename)}`
            + `&fileName=${encodeURIComponent(fileName)}`;
    }

    logout() {
        localStorage.removeItem('files');
    }
}

export default new FileService();